/**
 * 발주자 변경 모달 (관리자) — ⚠️ 위험 작업. $j.F.Admin.Order.BaljoojaForm
 *
 * 오더핸들(OrderHandle) 의 발주자 라벨 클릭 → window.baljooja_form() 이 아래처럼 연다:
 *   $j.Ui.JBModal.target('order-baljooja-modal', {
 *       target: '$j.F.Admin.Order.BaljoojaForm',
 *       data:   { ordernum, curOwnerNum, curName, curPhone },
 *       title:  '⚠️ 발주자 변경',
 *       width:  '540px',
 *   });
 *
 * 흐름: 소유자 검색(GET /adm/ajax/member/find?own=1) → 선택 → 위험확인 체크 → 변경(POST /adm/ajax/order/{n}/baljooja)
 * 서버는 발주자 식별정보 5개 컬럼만 교체(수수료/캐시/정산은 원 발주자 기준 유지).
 */
import Util from '../../../Common/Util';
export default class BaljoojaForm {
    constructor() {
        this.$wrap = null;
        this.selected = null; // 선택한 새 발주자 row
        this.rows = [];       // 마지막 검색 결과
    }

    destroy() {}

    init() {
        this.modalId = 'order-baljooja-modal';
        this.ordernum = this.data.ordernum;
        this.render();
        this.bind();
    }

    /** XSS 방지용 텍스트 이스케이프 */
    esc(s) {
        return $('<div>').text(s == null ? '' : s).html();
    }

    render() {
        const d = this.data;
        // 지금 발주자 — 관리자 회원 표기(`이름#번호` + 회원 팝오버)
        const cur = `${$j.F.Admin.Member.Pop.cell(d.curOwnerNum, d.curName)}${d.curPhone ? ' / ' + this.esc(d.curPhone) : ''}`;

        const html = `
        <style>
            .bjf { font-size:13px; color:#222; }
            .bjf-warn { background:#fff4f4; border:1px solid #f3c2c2; border-radius:6px; padding:10px 12px; margin-bottom:12px; }
            .bjf-warn b { color:#c0392b; }
            .bjf-warn ul { margin:6px 0 0; padding-left:18px; line-height:1.6; }
            .bjf-cur { display:flex; align-items:center; gap:8px; background:#f5f7fa; border-radius:6px; padding:8px 12px; margin-bottom:10px; }
            .bjf-cur > span { color:#888; font-size:12px; white-space:nowrap; }
            .bjf-no { color:#999; font-size:11px; }
            .bjf-search { display:flex; gap:6px; margin-bottom:8px; }
            .bjf-search input { flex:1; height:34px; border:1px solid #bbb; border-radius:4px; padding:2px 10px; background:#f2fbe4; }
            .bjf-search button { min-width:64px; height:34px; background:#19ce60; color:#fff; border:none; border-radius:4px; cursor:pointer; font-weight:bold; }
            .bjf-list { max-height:220px; overflow-y:auto; border:1px solid #eee; border-radius:6px; margin-bottom:10px; }
            .bjf-item { display:flex; align-items:center; gap:10px; padding:9px 12px; border-bottom:1px solid #f0f0f0; cursor:pointer; }
            .bjf-item:last-child { border-bottom:none; }
            .bjf-item:hover { background:#eef6ff; }
            .bjf-item.is-sel { background:#dbeeff; box-shadow:inset 3px 0 0 #2b7cff; }
            .bjf-item.is-cur { opacity:.55; cursor:default; }
            .bjf-item__name { font-weight:bold; }
            .bjf-item__phone { color:#555; }
            .bjf-item__cur { margin-left:auto; font-size:11px; color:#c0392b; border:1px solid #f3c2c2; border-radius:3px; padding:0 5px; }
            .bjf-empty { padding:20px; text-align:center; color:#999; }
            .bjf-selected { background:#eafaf0; border:1px solid #b9e6c9; border-radius:6px; padding:8px 12px; margin-bottom:10px; }
            .bjf-confirm { display:flex; align-items:center; gap:6px; margin-bottom:12px; cursor:pointer; }
            .bjf-confirm input { width:16px; height:16px; }
            .bjf-foot { display:flex; justify-content:flex-end; gap:8px; }
            .bjf-btn { height:36px; padding:0 18px; border:none; border-radius:4px; cursor:pointer; font-weight:bold; }
            .bjf-btn--ghost { background:#e6e6e6; color:#333; }
            .bjf-btn--danger { background:#c0392b; color:#fff; }
            .bjf-btn--danger:disabled { background:#ddb2ac; cursor:not-allowed; }
        </style>
        <div class="bjf">
            <div class="bjf-warn">
                <b>⚠️ 위험한 작업입니다</b>
                <ul>
                    <li>이 오더의 <b>발주자를 다른 소유자로 교체</b>합니다.</li>
                    <li>수수료율·캐시홀드·정산·-6차 는 <b>원 발주자 기준 그대로</b> 남습니다. (자동 재정산 안 함)</li>
                    <li>정산이 얽힌 오더라면 회계 처리를 먼저 확인하세요.</li>
                </ul>
            </div>
            <div class="bjf-cur"><span>현재 발주자</span><b>${cur}</b></div>
            <div class="bjf-search">
                <input type="text" id="bjf-kwd" placeholder="새 발주자 검색 (소유자명 · 전화 · 회원번호)" autocomplete="off">
                <button type="button" id="bjf-search-btn"><i class="fas fa-search"></i> 검색</button>
            </div>
            <div id="bjf-list" class="bjf-list"><div class="bjf-empty">소유자를 검색하세요.</div></div>
            <div id="bjf-selected" class="bjf-selected" style="display:none"></div>
            <label class="bjf-confirm"><input type="checkbox" id="bjf-agree"> 위 내용을 확인했으며 발주자를 변경합니다.</label>
            <div class="bjf-foot">
                <button type="button" id="bjf-cancel" class="bjf-btn bjf-btn--ghost">취소</button>
                <button type="button" id="bjf-apply" class="bjf-btn bjf-btn--danger" disabled>발주자 변경</button>
            </div>
        </div>`;

        $(`#${this.id}`).html(html);
        this.$wrap = $(`#${this.id}`);
    }

    bind() {
        const self = this;
        const $w = this.$wrap;

        $w.find('#bjf-search-btn').on('click', () => self.search());
        $w.find('#bjf-kwd').on('keydown', (e) => {
            if (e.keyCode === 13) { e.preventDefault(); self.search(); }
        });
        $w.find('#bjf-agree').on('change', () => self.refreshApplyState());
        $w.find('#bjf-cancel').on('click', () => $j.Ui.JBModal.close(self.modalId));
        $w.find('#bjf-apply').on('click', () => self.confirmApply());

        // 결과 항목 선택 (이벤트 위임)
        $w.on('click', '.bjf-item', function () {
            if ($(this).hasClass('is-cur')) return;
            self.pick($(this).data('num'));
        });

        setTimeout(() => $w.find('#bjf-kwd').trigger('focus'), 50);
    }

    search() {
        const self = this;
        const kwd = (this.$wrap.find('#bjf-kwd').val() || '').trim();
        if (kwd.length < 1) { $j.F.Admin.Util.tsalert('error', '검색어를 입력하세요.'); return; }

        const $list = this.$wrap.find('#bjf-list');
        $list.html('<div class="bjf-empty">검색중...</div>');
        $.ajax({
            type: 'get',
            url: '/adm/ajax/member/find',
            data: { kwd, own: 1, limit: 20 },
            dataType: 'json',
            success(rows) {
                self.rows = Array.isArray(rows) ? rows : [];
                self.renderList();
            },
            error() { $list.html('<div class="bjf-empty" style="color:var(--adm-kw-red, red)">검색에 실패했습니다.</div>'); },
        });
    }

    renderList() {
        const $list = this.$wrap.find('#bjf-list');
        if (!this.rows.length) {
            $list.html('<div class="bjf-empty">검색 결과가 없습니다.</div>');
            return;
        }
        const cur = String(this.data.curOwnerNum);
        const html = this.rows.map((r) => {
            const isCur = String(r.num) === cur;
            return `<div class="bjf-item ${isCur ? 'is-cur' : ''}" data-num="${r.num}">`
                + `<span class="bjf-item__name">${this.esc(r.mem_name)}</span>`
                + `<span class="bjf-item__phone">${this.esc(r.mem_phone)}</span>`
                + `<span class="bjf-no">#${r.num}</span>`
                + (isCur ? `<span class="bjf-item__cur">현재</span>` : '')
                + `</div>`;
        }).join('');
        $list.html(html);
    }

    pick(num) {
        const r = this.rows.find((x) => String(x.num) === String(num));
        if (!r) return;
        this.selected = r;

        this.$wrap.find('.bjf-item').removeClass('is-sel');
        this.$wrap.find(`.bjf-item[data-num="${num}"]`).addClass('is-sel');
        this.$wrap.find('#bjf-selected').show().html(
            `변경할 발주자: <b>${this.esc(r.mem_name)}</b> ${this.esc(r.mem_phone)} <span class="bjf-no">#${r.num}</span>`
        );
        this.refreshApplyState();
    }

    refreshApplyState() {
        const ok = this.selected && this.$wrap.find('#bjf-agree').is(':checked');
        this.$wrap.find('#bjf-apply').prop('disabled', !ok);
    }

    confirmApply() {
        const self = this;
        if (!this.selected) return;
        if (!this.$wrap.find('#bjf-agree').is(':checked')) return;
        // swalert 는 '<' 가 든 제목을 HTML 로 그린다 — 회원명이 든 문장이라 텍스트 슬롯(Dialog)으로 직접 연다
        $j.Ui.Dialog.open({
            tone:      'warn',
            title:     `발주자를 '${this.selected.mem_name}'(으)로 변경합니다.`,
            desc:      '수수료·캐시·정산은 자동으로 재처리되지 않습니다. 계속할까요?',
            confirm:   '확인',
            onConfirm: () => self.apply(),
        });
    }

    apply() {
        const self = this;
        this.$wrap.find('#bjf-apply').prop('disabled', true);
        $.ajax({
            type: 'post',
            url: `/adm/ajax/order/${self.ordernum}/baljooja`,
            data: { newOwnerNum: self.selected.num },
            dataType: 'json',
            success(res) {
                if (res && res.result) {
                    $j.F.Admin.Util.tsalert('success', '발주자가 변경되었습니다.');
                    $j.Ui.JBModal.close(self.modalId);
                    location.reload();
                } else {
                    $j.F.Admin.Util.tsalert('error', (res && res.message) || '변경에 실패했습니다.');
                    self.refreshApplyState();
                }
            },
            error() {
                $j.F.Admin.Util.tsalert('error', '요청 처리중 오류가 발생했습니다.');
                self.refreshApplyState();
            },
        });
    }
}
